import React, {FC} from "react";
import logo_green from "../logo_green.png";
import {IconButton, Link} from "@material-ui/core";
import {Menu} from "@material-ui/icons";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";
import clsx from "clsx";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
    list: {
        width: 250,
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        flexGrow: 1,
    }
}));

export const OrderEngineMobileHeader: FC = () => {
    const classes = useStyles();
    const [menuOpen, setMenuOpen] = React.useState(false);

    const toggleDrawer = (open: boolean) => (
        event: React.KeyboardEvent | React.MouseEvent,
    ) => {
        if (
            event &&
            event.type === 'keydown' &&
            ((event as React.KeyboardEvent).key === 'Tab' ||
                (event as React.KeyboardEvent).key === 'Shift')
        ) {
            return setMenuOpen(false);
        }
        setMenuOpen(!open);
    };

    return (
        <React.Fragment>
            <div style={{display: "flex", justifyContent: "space-between", width: "100%"}}>
                <img
                    style={{maxHeight: 56}}
                    alt="logo"
                    src={logo_green}
                />
                <IconButton edge="end" onClick={toggleDrawer(menuOpen)}>
                    <Menu/>
                </IconButton>
            </div>
            <SwipeableDrawer
                anchor={"right"}
                open={menuOpen}
                onClose={toggleDrawer(menuOpen)}
                onOpen={toggleDrawer(menuOpen)}
            >
                <div
                    className={clsx(classes.list)}
                    role="presentation"
                    onClick={toggleDrawer(menuOpen)}
                    onKeyDown={toggleDrawer(menuOpen)}
                >
                    <List>
                        <ListItem
                            component={Link}
                            href="https://www.diefleissigenenkel.de/heckenschnitt/"
                            target="_blank"
                            button
                        >
                            <ListItemText primary={"Heckenschnitt"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            button
                            component={Link}
                            href="https://www.diefleissigenenkel.de/gartenhilfe/"
                            target="_blank"
                        >
                            <ListItemText primary={"Gartenhilfe"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            component={Link}
                            href="https://www.diefleissigenenkel.de"
                            target="_blank"
                        >
                            <ListItemText primary={"Vertikutieren"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            component={Link}
                            href="https://www.diefleissigenenkel.de/obstbaumschnitt/"
                            target="_blank"
                        >
                            <ListItemText primary={"Obstbaumschnitt"}/>
                        </ListItem>
                        <Divider/>
                        <ListItem
                            component={Link}
                            href="https://www.diefleissigenenkel.de/kontakt/"
                            target="_blank"
                        >
                            <ListItemText primary={"Kontakt"}/>
                        </ListItem>
                    </List>
                </div>
            </SwipeableDrawer>
        </React.Fragment>
    )
}
